import FeatureGates from '@atlaskit/feature-gate-js-client';

enum PAGE_PROPERTIES_REPORT_COHORTS {
	CONTROL = 'control',
	EXPERIMENT = 'experiment',
}

/**
 * NOTE: because fireExperimentExposure defaults TRUE, for this experiment it is important
 * we call this function only when we are about to render the PPR macro!
 */
export const getPagePropertiesReportExperimentEnabled = () => {
	const cohort = FeatureGates.getExperimentValue<PAGE_PROPERTIES_REPORT_COHORTS>(
		'confluence_frontend_ppr_adf_rendering_experiment',
		'cohort',
		PAGE_PROPERTIES_REPORT_COHORTS.CONTROL,
	);

	return cohort === PAGE_PROPERTIES_REPORT_COHORTS.EXPERIMENT;
};
